import { isArray, PartTypes } from 'vdlib';
import ReduxHelper, { setFilterFromAction } from 'lib/ReduxHelper';
import { AUCTIONS_ACTION_TYPES as AT } from './Auctions.actions';
import { getImageUrl, getThumbUrl } from 'lib/Utils';
import moment from 'moment';
import 'moment/locale/el';

const defaultAuctionsFilterState = [];

const defaultAuctionMapper = auction =>
  auction.EndDate || Array.isArray(auction.Images)
    ? {
        ...auction,
        EndDate: moment.utc(auction.EndDate),
        // OnlineEndDate: moment.utc(auction.OnlineEndDate),
        CreatedDate: moment.utc(auction.CreatedDate),
        Images: (auction.Images || []).map(img => {
          return {
            Filepath: getImageUrl(img.Filename, auction.FolderNumber),
            Order: img.OrderNum,
          };
        }),
        Thumbnails: (auction.Images || []).map(img => {
          return {
            Filepath: getThumbUrl(img.Filename, auction.FolderNumber),
            Order: img.OrderNum,
          };
        }),
      }
    : auction;

export const defaultState = {
  message: null,
  filters: defaultAuctionsFilterState,

  fetchingCurrentAuctions: false,
  currentAuctions: null,

  fetchingPendingApprovalAuctions: false,
  pendingApprovalAuctions: null,

  fetchingForSelectionAuctions: false,
  forSelectionAuctions: null,

  fetchingParticipateToAuctions: false,
  participateToAuctions: null,

  fetchingForAcceptanceAuctions: false,
  forAcceptanceAuctions: null,

  fetchingForDispatchAuctions: false,
  forDispatchAuctions: null,

  fetchingDispatchProblemAuctions: false,
  dispatchProblemAuctions: null,

  fetchingRejectedAuctions: false,
  rejectedAuctions: null,

  fetchingCompletedAuctions: false,
  completedAuctions: null,

  fetchingMerchantSummary: false,
  merchantSummaryData: null,

  fetchingLostAuctions: false,
  lostAuctions: null,

  fetchingCurrentAuction: false,
  currentAuction: null,
  fetchingCurrentAuctionBids: false,
  currentAuctionBids: null,
  fetchingCurrentAuctionComments: false,
  currentAuctionComments: null,
  currentAuctionCommentsError: null,

  creatingAuctionBids: false,

  creatingAuction: false,
  creationError: null,
  auctionCreated: false,

  auctionEdited: null,
  editError: null,
  editingAuction: false,

  startingAuctions: false,
  endingAuction: false,
  endingAuctions: false,
  acceptingAuction: false,
  rejectingAuction: false,
  exportingAuction: false,
  cancellingAuction: false,
  dispatchingAuction: false,

  fetchingPartPriceHistory: false,
  partPriceHistory: null,

  folderSearchResults: null,
  folderSearchPending: false,
  folderSearchError: null,

  fetchingImages: false,
  images: null,
  imagesError: null,

  uploadingImages: false,
  uploadImages: null,

  deleteImages: null,
  deleteImagesError: null,
  deleteImagesPending: false,

  reorderImagesPending: false,
  reorderImages: null,
  reorderImagesError: null,

  removeImageLicensePlate: null,
  removeImageLicensePlateError: null,
  removeImageLicensePlatePending: false,

  addedAuctionComment: null,
  addingAuctionComment: true,
  addAuctionCommentError: null,

  fetchingAuctionPartImages: false,
  auctionPartImages: null,
  auctionPartImagesError: null,

  uploadingAuctionPartImages: false,
  uploadAuctionPartImages: null,

  deleteAuctionPartImages: null,
  deleteAuctionPartImagesError: null,
  deleteAuctionPartImagesPending: false,
};

const auctionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.AUCTIONS_FETCH_CURRENT:
      return Object.assign({}, state, { fetchingCurrentAuctions: true });
    case AT.AUCTIONS_FETCH_CURRENT_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctions: false,
        currentAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_CURRENT_FAIL:
      return Object.assign({}, state, {
        currentAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_CURRENT:
      return Object.assign({}, state, {
        fetchingCurrentAuctions: false,
        currentAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: true,
      });
    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL_SUCCESS:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: false,
        pendingApprovalAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL_FAIL:
      return Object.assign({}, state, {
        pendingApprovalAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_PENDINGAPPROVAL:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: false,
        pendingApprovalAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORSELECTION:
      return Object.assign({}, state, { fetchingForSelectionAuctions: true });
    case AT.AUCTIONS_FETCH_FORSELECTION_SUCCESS:
      return Object.assign({}, state, {
        fetchingForSelectionAuctions: false,
        forSelectionAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORSELECTION_FAIL:
      return Object.assign({}, state, {
        forSelectionAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORSELECTION:
      return Object.assign({}, state, {
        fetchingForSelectionAuctions: false,
        forSelectionAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_PARTICIPATETO:
      return Object.assign({}, state, { fetchingParticipateToAuctions: true });
    case AT.AUCTIONS_FETCH_PARTICIPATETO_SUCCESS:
      return Object.assign({}, state, {
        fetchingParticipateToAuctions: false,
        participateToAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_PARTICIPATETO_FAIL:
      return Object.assign({}, state, {
        participateToAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_PARTICIPATETO:
      return Object.assign({}, state, {
        fetchingParticipateToAuctions: false,
        participateToAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORACCEPTANCE:
      return Object.assign({}, state, { fetchingForAcceptanceAuctions: true });
    case AT.AUCTIONS_FETCH_FORACCEPTANCE_SUCCESS:
      return Object.assign({}, state, {
        fetchingForAcceptanceAuctions: false,
        forAcceptanceAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORACCEPTANCE_FAIL:
      return Object.assign({}, state, {
        forAcceptanceAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORACCEPTANCE:
      return Object.assign({}, state, {
        fetchingForAcceptanceAuctions: false,
        forAcceptanceAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORDISPATCH:
      return Object.assign({}, state, { fetchingForDispatchAuctions: true });
    case AT.AUCTIONS_FETCH_FORDISPATCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingForDispatchAuctions: false,
        forDispatchAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORDISPATCH_FAIL:
      return Object.assign({}, state, {
        forDispatchAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORDISPATCH:
      return Object.assign({}, state, {
        fetchingForDispatchAuctions: false,
        forDispatchAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: true,
      });
    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM_SUCCESS:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: false,
        dispatchProblemAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM_FAIL:
      return Object.assign({}, state, {
        dispatchProblemAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_DISPATCHPROBLEM:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: false,
        dispatchProblemAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_REJECTED:
      return Object.assign({}, state, { fetchingRejectedAuctions: true });
    case AT.AUCTIONS_FETCH_REJECTED_SUCCESS:
      return Object.assign({}, state, {
        fetchingRejectedAuctions: false,
        rejectedAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_REJECTED_FAIL:
      return Object.assign({}, state, {
        rejectedAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_REJECTED:
      return Object.assign({}, state, {
        fetchingRejectedAuctions: false,
        rejectedAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_COMPLETED:
      return Object.assign({}, state, { fetchingCompletedAuctions: true });
    case AT.AUCTIONS_FETCH_COMPLETED_SUCCESS:
      return Object.assign({}, state, {
        fetchingCompletedAuctions: false,
        completedAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_COMPLETED_FAIL:
      return Object.assign({}, state, {
        completedAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_COMPLETED:
      return Object.assign({}, state, {
        fetchingCompletedAuctions: false,
        completedAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_LOST:
      return Object.assign({}, state, { fetchingLostAuctions: true });
    case AT.AUCTIONS_FETCH_LOST_SUCCESS:
      return Object.assign({}, state, {
        fetchingLostAuctions: false,
        lostAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_LOST_FAIL:
      return Object.assign({}, state, {
        lostAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_LOST:
      return Object.assign({}, state, {
        fetchingLostAuctions: false,
        lostAuctions: null,
        error: null,
      });

    case AT.AUCTION_UPLOAD:
      return Object.assign({}, state, {
        creatingAuction: true,
        creationError: null,
      });
    case AT.AUCTION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        creatingAuction: false,
        auctionCreated: true,
        creationError: null,
        newAuctionGarage: action.payload.data.Content.Garage,
      });
    case AT.AUCTION_UPLOAD_FAIL:
      return Object.assign({}, state, {
        creatingAuction: false,
        creationError: action.error,
      });

    case AT.AUCTION_CREATE:
      return Object.assign({}, state, {
        creatingAuction: true,
        creationError: null,
      });
    case AT.AUCTION_CREATE_SUCCESS:
      return Object.assign({}, state, {
        creatingAuction: false,
        auctionCreated: action.payload.Auction.ID,
        creationError: null,
      });
    case AT.AUCTION_CREATE_FAIL:
      return Object.assign({}, state, {
        creatingAuction: false,
        creationError: action.error,
      });
    case AT.AUCTION_CREATE_CLEAR:
      return {
        ...state,
        creatingAuction: false,
        auctionCreated: null,
        creationError: null,
        newAuctionGarage: null,
      };

    case AT.AUCTION_EDIT:
      return Object.assign({}, state, {
        editingAuction: true,
        editError: null,
      });
    case AT.AUCTION_EDIT_SUCCESS:
      return Object.assign({}, state, {
        editingAuction: false,
        auctionEdited: action.payload.Auction.ID,
        editError: null,
      });
    case AT.AUCTION_EDIT_FAIL:
      return Object.assign({}, state, {
        editingAuction: false,
        editError: action.error,
      });
    case AT.AUCTION_EDIT_CLEAR:
      return {
        ...state,
        editingAuction: false,
        auctionEdited: null,
        editError: null,
      };

    case AT.AUCTION_FETCH_BIDS:
      return Object.assign({}, state, { fetchingCurrentAuctionBids: true });
    case AT.AUCTION_FETCH_BIDS_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: action.payload.Bids,
      });
    case AT.AUCTION_FETCH_BIDS_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBidsError: action.error,
      });
    case AT.AUCTION_CLEAR_BIDS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: null,
        currentAuctionBidsError: null,
      });

    case AT.AUCTION_FETCH_COMMENTS:
      return Object.assign({}, state, { fetchingCurrentAuctionComments: true });
    case AT.AUCTION_FETCH_COMMENTS_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: action.payload.Comments,
      });
    case AT.AUCTION_FETCH_COMMENTS_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionCommentsError: action.error,
      });
    case AT.AUCTION_CLEAR_COMMENTS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: null,
        currentAuctionCommentsError: null,
      });

    case AT.AUCTION_FETCH:
      return Object.assign({}, state, { fetchingCurrentAuction: true });
    case AT.AUCTION_FETCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        currentAuction: action.payload,
      });
    case AT.AUCTION_FETCH_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        message: ReduxHelper.formatMessage(action),
      });
    case AT.AUCTION_CLEAR:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        currentAuction: null,
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: null,
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: null,
        error: null,
      });

    case AT.AUCTIONS_START:
      return Object.assign({}, state, { startingAuctions: true });
    case AT.AUCTIONS_START_SUCCESS:
      let newStartState = { startingAuctions: false },
        startedAuctions = action.payload.Auctions.map(defaultAuctionMapper),
        startedAuctionIds = startedAuctions.map(a => a.ID);
      if (state.currentAuction != null)
        newStartState.currentAuction = startedAuctions[0];
      else if (state.pendingApprovalAuctions != null)
        newStartState.pendingApprovalAuctions = state.pendingApprovalAuctions
          .map(a =>
            startedAuctionIds.indexOf(a.ID) >= 0 ? null : Object.assign({}, a)
          )
          .filter(a => a != null);

      return Object.assign({}, state, newStartState);
    case AT.AUCTIONS_START_FAIL:
      return Object.assign({}, state, {
        startingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_END:
      return Object.assign({}, state, { endingAuction: true });
    case AT.AUCTION_END_SUCCESS:
      let newEndState = { endingAuction: false },
        endedAuction = action.payload.Auction || {};
      if (state.currentAuction != null)
        newEndState.currentAuction = endedAuction;
      if (state.forSelectionAuctions != null)
        newEndState.forSelectionAuctions = state.forSelectionAuctions.filter(
          a => a.ID !== endedAuction.ID
        );
      return Object.assign({}, state, newEndState);
    case AT.AUCTION_END_FAIL:
      return Object.assign({}, state, {
        endingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_SELECTED_END:
      return Object.assign({}, state, { endingAuctions: true });
    case AT.AUCTIONS_SELECTED_END_SUCCESS:
      let newEndAuctionsState = { endingAuctions: false },
        endedAuctions = action.payload.Auctions.map(defaultAuctionMapper),
        endedAuctionIds = endedAuctions.map(a => a.ID);
      if (state.currentAuction != null)
        newEndAuctionsState.currentAuction = endedAuctions[0];
      if (state.forSelectionAuctions != null)
        newEndAuctionsState.forSelectionAuctions = state.forSelectionAuctions
          .map(a =>
            endedAuctionIds.indexOf(a.ID) >= 0 ? null : Object.assign({}, a)
          )
          .filter(a => a != null);
      return Object.assign({}, state, newEndAuctionsState);
    case AT.AUCTIONS_SELECTED_END_FAIL:
      return Object.assign({}, state, {
        endingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_ACCEPT:
      return Object.assign({}, state, { acceptingAuction: true });
    case AT.AUCTION_ACCEPT_SUCCESS:
      let newState = { acceptingAuction: false },
        acceptedAuction = action.payload.Auction || {};
      if (state.currentAuction != null)
        newState.currentAuction = acceptedAuction;
      if (state.forAcceptanceAuctions != null)
        newState.forAcceptanceAuctions = state.forAcceptanceAuctions
          .map(a => (a.ID === acceptedAuction.ID ? null : Object.assign({}, a)))
          .filter(a => a != null);

      return Object.assign({}, state, newState);
    case AT.AUCTION_ACCEPT_FAIL:
      return Object.assign({}, state, {
        acceptingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_DISPATCH:
      return Object.assign({}, state, { dispatchingAuction: true });
    case AT.AUCTION_DISPATCH_SUCCESS:
      let newDispatchState = { dispatchingAuction: false },
        dispatchedAuction = action.payload.Auction || {};
      if (state.currentAuction != null)
        newDispatchState.currentAuction = dispatchedAuction.id;
      else if (state.forDispatchAuctions != null)
        newDispatchState.forDispatchAuctions = state.forDispatchAuctions
          .map(a =>
            a.ID === dispatchedAuction.ID ? null : Object.assign({}, a)
          )
          .filter(a => a != null);

      return Object.assign({}, state, newDispatchState);
    case AT.AUCTION_DISPATCH_FAIL:
      return Object.assign({}, state, {
        dispatchingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_REJECT:
      return Object.assign({}, state, { rejectingAuction: true });
    case AT.AUCTION_REJECT_SUCCESS:
      return Object.assign({}, state, {
        rejectingAuction: false,
        currentAuction: action.payload.Auction,
      });
    case AT.AUCTION_REJECT_FAIL:
      return Object.assign({}, state, {
        rejectingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_CANCEL:
      return Object.assign({}, state, { cancellingAuctions: true });
    case AT.AUCTIONS_CANCEL_SUCCESS:
      let newCancelState = { cancellingAuctions: false },
        cancelledAuctions = action.payload.Auctions.map(defaultAuctionMapper),
        cancelledAuctionIds = cancelledAuctions.map(a => a.ID);
      if (state.currentAuction != null)
        newCancelState.currentAuction = cancelledAuctions[0];
      else if (state.forSelectionAuctions != null)
        newCancelState.forSelectionAuctions = state.forSelectionAuctions
          .map(a =>
            cancelledAuctionIds.indexOf(a.ID) >= 0 ? null : Object.assign({}, a)
          )
          .filter(a => a != null);
      else if (state.pendingApprovalAuctions != null)
        newCancelState.pendingApprovalAuctions = state.pendingApprovalAuctions
          .map(a =>
            cancelledAuctionIds.indexOf(a.ID) >= 0 ? null : Object.assign({}, a)
          )
          .filter(a => a != null);

      return Object.assign({}, state, newCancelState);
    case AT.AUCTIONS_CANCEL_FAIL:
      return Object.assign({}, state, {
        cancellingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_CLEAR:
      return Object.assign({}, state, {
        currentAuctions: null,
        currentAuctionBids: null,
      });

    case AT.AUCTION_CREATE_BIDS:
      return Object.assign({}, state, { creatingAuctionBids: true });
    case AT.AUCTION_CREATE_BIDS_SUCCESS:
      let createdBids = action.payload.Bids,
        createdPartTypes = createdBids.map(b => b.PartTypeID),
        auctionId = createdBids[0].AuctionID,
        key = null;
      if (isArray(state.currentAuctions)) key = 'currentAuctions';
      else if (isArray(state.participateToAuctions))
        key = 'participateToAuctions';

      if (key == null)
        return Object.assign({}, state, { creatingAuctionBids: false });

      let auction = state[key].find(auction => auction.ID === auctionId);
      if (auction == null)
        return Object.assign({}, state, { creatingAuctionBids: false });

      let newAuction = Object.assign({}, auction, { Bids: createdBids });
      if (isArray(auction.Bids))
        for (let bid of auction.Bids.filter(
          b => createdPartTypes.indexOf(b.PartTypeID) < 0
        ))
          newAuction.Bids.push(Object.assign({}, bid));

      return Object.assign({}, state, {
        creatingAuctionBids: false,
        [key]: state[key].map(auction =>
          auction.ID === auctionId ? newAuction : auction
        ),
      });
    case AT.AUCTION_CREATE_BIDS_FAIL:
      return Object.assign({}, state, {
        creatingAuctionBids: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.SET_AUCTIONS_GRID_FILTER:
      return {
        ...state,
        filters: setFilterFromAction(action, state.filters),
      };
    case AT.CLEAR_AUCTIONS_GRID_FILTERS:
      return { ...state, filters: defaultAuctionsFilterState };

    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY:
      return Object.assign({}, state, { fetchingMerchantSummary: true });
    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY_SUCCESS:
      return Object.assign({}, state, {
        fetchingMerchantSummary: false,
        merchantSummaryData: action.payload,
        error: null,
      });
    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY_FAIL:
      return Object.assign({}, state, {
        merchantSummaryData: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_MERCHANT_SUMMARY:
      return Object.assign({}, state, {
        fetchingMerchantSummary: false,
        merchantSummaryData: null,
        error: null,
      });

    case AT.AUCTIONS_EXPORT_PDF:
      return Object.assign({}, state, { exportingAuction: true });
    case AT.AUCTIONS_EXPORT_PDF_SUCCESS:
      // // decode base64 string, remove space for IE compatibility
      let binary = atob(action.payload.Content.replace(/\s/g, '')),
        len = binary.length,
        buffer = new ArrayBuffer(len),
        view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) view[i] = binary.charCodeAt(i);

      // create the blob object with content-type "application/pdf"
      let blob = new Blob([view], { type: 'application/octet-stream' }),
        url = URL.createObjectURL(blob),
        a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = action.payload.FileName;
      a.click();
      window.URL.revokeObjectURL(url);

      return Object.assign({}, state, {
        exportingAuction: false,
      });
    case AT.AUCTIONS_EXPORT_PDF_FAIL:
      return Object.assign({}, state, {
        exportingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_FETCH_HISTORY:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: true,
        partPriceHistoryError: null,
      });
    case AT.AUCTIONS_FETCH_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistory: action.payload.PartPriceHistories,
      });
    case AT.AUCTIONS_FETCH_HISTORY_FAIL:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistoryError: ReduxHelper.formatMessage(action),
      });
    case AT.AUCTIONS_CLEAR_HISTORY:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistory: null,
        partPriceHistoryError: null,
      });

    case AT.NEW_AUCTION_SET_GARAGE:
      return Object.assign({}, state, { newAuctionGarage: action.payload });
    case AT.NEW_AUCTION_CLEAR_GARAGE:
      return Object.assign({}, state, { newAuctionGarage: null });

    case AT.SEARCH_FOLDERS_BY_NUMBER:
      return {
        ...state,
        folderSearchResults: null,
        folderSearchPending: true,
        folderSearchError: null,
      };
    case AT.SEARCH_FOLDERS_BY_NUMBER_SUCCESS:
      return {
        ...state,
        folderSearchResults: action.payload.Folders,
        folderSearchPending: false,
        folderSearchError: null,
      };
    case AT.SEARCH_FOLDERS_BY_NUMBER_FAIL:
      return {
        ...state,
        folderSearchResults: null,
        folderSearchPending: false,
        folderSearchError: action.payload,
      };
    case AT.CLEAR_SEARCH_FOLDERS_BY_NUMBER:
      return {
        ...state,
        folderSearchResults: null,
        folderSearchPending: false,
        folderSearchError: null,
      };

    case AT.AUCTION_FETCH_IMAGES:
      return { ...state, fetchingImages: true, images: null };
    case AT.AUCTION_FETCH_IMAGES_SUCCESS:
      return { ...state, fetchingImages: false, images: action.payload.Images };
    case AT.AUCTION_FETCH_IMAGES_FAIL:
      return {
        ...state,
        fetchingImages: false,
        images: null,
        imagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_IMAGES:
      return {
        ...state,
        fetchingImages: false,
        images: null,
        imagesError: null,
      };

    case AT.AUCTION_UPLOAD_IMAGES:
      return { ...state, uploadingImages: true, uploadImages: null };
    case AT.AUCTION_UPLOAD_IMAGES_SUCCESS:
      return { ...state, uploadingImages: false, uploadImages: action.payload };
    case AT.AUCTION_UPLOAD_IMAGES_FAIL:
      return {
        ...state,
        uploadingImages: false,
        uploadImages: null,
        uploadImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_UPLOAD_IMAGES:
      return {
        ...state,
        uploadingImages: false,
        uploadImages: null,
        uploadImagesError: null,
      };

    case AT.AUCTION_DELETE_IMAGES:
      return { ...state, deleteImagesPending: true, deleteImages: null };
    case AT.AUCTION_DELETE_IMAGES_SUCCESS:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: action.payload,
      };
    case AT.AUCTION_DELETE_IMAGES_FAIL:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: null,
        deleteImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_DELETE_IMAGES:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: null,
        deleteImagesError: null,
      };

    case AT.AUCTION_REORDER_IMAGES:
      return { ...state, reorderImagesPending: true, reorderImages: null };
    case AT.AUCTION_REORDER_IMAGES_SUCCESS:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: action.payload,
      };
    case AT.AUCTION_REORDER_IMAGES_FAIL:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: null,
        reorderImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_REORDER_IMAGES:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: null,
        reorderImagesError: null,
      };

    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE:
      return {
        ...state,
        removeImageLicensePlatePending: true,
        removeImageLicensePlate: null,
      };
    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_SUCCESS:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: action.payload,
      };
    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_FAIL:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: null,
        removeImageLicensePlateError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTIONS_CLEAR_REMOVE_IMAGE_LICENSE_PLATE:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: null,
        removeImageLicensePlateError: null,
      };

    case AT.AUCTION_COMMENT:
      return {
        ...state,
        addedAuctionComment: null,
        addingAuctionComment: true,
        addAuctionCommentError: null,
      };
    case AT.AUCTION_COMMENT_SUCCESS:
      return {
        addedAuctionComment: action.payload,
        addingAuctionComment: false,
        addAuctionCommentError: null,
      };
    case AT.AUCTION_COMMENT_FAIL:
      return {
        addedAuctionComment: null,
        addingAuctionComment: false,
        addAuctionCommentError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_COMMENT_CLEAR:
      return {
        ...state,
        addedAuctionComment: null,
        addingAuctionComment: false,
        addAuctionCommentError: null,
      };

    case AT.AUCTION_FETCH_PART_IMAGES:
      return {
        ...state,
        fetchingAuctionPartImages: true,
        auctionPartImages: null,
      };
    case AT.AUCTION_FETCH_PART_IMAGES_SUCCESS:
      return {
        ...state,
        fetchingAuctionPartImages: false,
        auctionPartImages: action.payload.Images,
      };
    case AT.AUCTION_FETCH_PART_IMAGES_FAIL:
      return {
        ...state,
        fetchingAuctionPartImages: false,
        auctionPartImages: null,
        auctionPartImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_PART_IMAGES:
      return {
        ...state,
        fetchingAuctionPartImages: false,
        auctionPartImages: null,
        auctionPartImagesError: null,
      };

    case AT.AUCTION_UPLOAD_PART_IMAGES:
      return {
        ...state,
        uploadingAuctionPartImages: true,
        uploadAuctionPartImages: null,
      };
    case AT.AUCTION_UPLOAD_PART_IMAGES_SUCCESS:
      return {
        ...state,
        uploadingAuctionPartImages: false,
        uploadAuctionPartImages: action.payload,
      };
    case AT.AUCTION_UPLOAD_PART_IMAGES_FAIL:
      return {
        ...state,
        uploadingAuctionPartImages: false,
        uploadAuctionPartImages: null,
        uploadAuctionPartImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_UPLOAD_PART_IMAGES:
      return {
        ...state,
        uploadingAuctionPartImages: false,
        uploadAuctionPartImages: null,
        uploadAuctionPartImagesError: null,
      };
    case AT.AUCTION_DELETE_PART_IMAGES:
      return {
        ...state,
        deleteAuctionPartImagesPending: true,
        deleteAuctionPartImages: null,
      };
    case AT.AUCTION_DELETE_PART_IMAGES_SUCCESS:
      return {
        ...state,
        deleteAuctionPartImagesPending: false,
        deleteAuctionPartImages: action.payload,
      };
    case AT.AUCTION_DELETE_PART_IMAGES_FAIL:
      return {
        ...state,
        deleteAuctionPartImagesPending: false,
        deleteAuctionPartImages: null,
        deleteAuctionPartImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_DELETE_PART_IMAGES:
      return {
        ...state,
        deleteAuctionPartImagesPending: false,
        deleteAuctionPartImages: null,
        deleteAuctionPartImagesError: null,
      };

    default:
      return state;
  }
};

export default auctionsReducer;
